import ReportHeader from "reports/components/Reports/ReportHeader";
import { useProcessGroupNameAndMachemetryIds } from "reports/components/Reports/reportUtils";
import LoadingCircle from "reports/components/simple/LoadingCircle";
import { useAtom } from "jotai";
import { isEmpty } from "lodash";
import { format } from "date-fns";
import { lastNMonthDataAtom } from "reports/store/store";
import { FORMAT_MONTH } from "reports/utils/timeUtils";
import LastNMonthGetter from "../Getters/LastNMonthGetter";
import MonthlyPerformanceChart from "../MonthlyPerformanceChart";
import { useParams } from "react-router";
import { ReportParams } from "reports/types";

export default function MonthlyPerformanceReport() {
  const { processGroupName, machemetryIds } =
    useProcessGroupNameAndMachemetryIds({});

  const [lastNMonthData] = useAtom(lastNMonthDataAtom);
  const { ckey: tenant } = useParams() as ReportParams;
  const numMonths = 10;
  const sortedLastNMonthsData = lastNMonthData.sort((a, b) => {
    return b.ge - a.ge;
  });

  return (
    <>
      <LastNMonthGetter numMonths={numMonths} machemetryIds={machemetryIds} />

      {!isEmpty(lastNMonthData) &&
      machemetryIds.length > 0 &&
      lastNMonthData.length === numMonths ? (
        <>
          <ReportHeader
            title={`Monthly  Performance Report`}
            subheader={`${tenant.toUpperCase()} - ${processGroupName.toUpperCase()}`}
            headerDate={`Month - ${format(
              sortedLastNMonthsData[0].ge,
              FORMAT_MONTH
            )}`}
          ></ReportHeader>
          <MonthlyPerformanceChart pnlBreakdowns={sortedLastNMonthsData} />
        </>
      ) : (
        <LoadingCircle />
      )}
    </>
  );
}
